import { css } from '@emotion/css'
import { spacing, fontSize } from '../../../styles'
import getThemeColors, { colors } from '../../../themes'
import { hexToRgba } from '../../../themes/helpers'
import { accessiblyHidden } from '../../../utils/styleUtils'

const outerCircleSize = 20
const innerCircleSize = 12
const innerCircleOffset = (outerCircleSize - innerCircleSize) / 2

const pseudoRadio = {
  display: 'block',
  content: '""',
  borderRadius: '50%',
  boxSizing: 'border-box',
  cursor: 'pointer',
  width: outerCircleSize,
  height: outerCircleSize,
  flex: 'none',
}

const styles = {
  input: css(accessiblyHidden),

  label: css({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    paddingRight: spacing.large,
    marginBottom: spacing.default,
    cursor: 'pointer',
    color: colors.blackPearl,
    fontSize: fontSize.default,

    '&::before': {
      ...pseudoRadio,
      border: `1px solid ${colors.geyser}`,
      marginRight: spacing.default,
    },
  }),
}

export default styles

export const inputTheme = theme => {
  const themed = getThemeColors(theme)

  return css({
    '&:checked + label::before': {
      borderColor: themed.base,
      backgroundColor: themed.light,
    },

    '&:checked + label::after': {
      ...pseudoRadio,
      position: 'absolute',
      width: innerCircleSize,
      height: innerCircleSize,
      left: innerCircleOffset,
      top: '50%',
      transform: 'translateY(-50%)',
      backgroundColor: themed.base,
    },

    '&:not(:disabled) + label:hover::before': {
      borderColor: themed.base,
    },

    '&:focus + label::before': {
      boxShadow: `0 0 2px 1px ${hexToRgba(themed.medium, 0.5)}`,
    },

    '&:disabled + label::before': {
      backgroundColor: colors.athensGray,
    },
  })
}
